import React, { ChangeEvent, Fragment, useEffect, useRef, useState } from 'react';
import { IFilesToUpload, IProductReturn } from './interfaces';
import { PageBarHeader } from '../../../components/migrated/pageheader';
import { Button, Grid, Typography, TextField } from '@material-ui/core';
import { useSuppliersGql } from './graphql/suppliers';
import { useSnackbar, useEnvironment } from '../../../hooks';
import { DatePicker } from '../../../components/migrated/hook-form-inputs/datepicker';
import { useStyles } from './styles';
import Add from '@material-ui/icons/Add';
import { AutocompleteMultiple } from '../../../components/migrated/hook-form-inputs/autocompletemultiple';
import { useReturnReasonsListGql } from './graphql/qualityReturnReasonsList';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useProductsGql } from './graphql/products';
import { Controller, FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Autocomplete } from '../../../components/migrated/hook-form-inputs/autocomplete';
import { ModalLimiteSize } from './components/modalLimiteSize';
import { ModalPreview } from './components/modalPreview';
import { productReturnFormSchema } from './validations';
import { useApi } from '../../../services/api';
import moment from 'moment';
import Cookies from 'universal-cookie';
import { ModalProcessing } from './components/modalProcessing';
import { ErrorMessage } from '@hookform/error-message';

export const ProductReturnAdd = (props: IProductReturn) => {
  const cookies = new Cookies();
  const maxLength = 4000;
  const { api, paths } = useApi();
  const { router } = props;
  const classes = useStyles();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const inputFilesRef = useRef<HTMLInputElement>({} as HTMLInputElement);
  const [filesToUpload, setFilesToUpload] = useState<IFilesToUpload[]>([] as IFilesToUpload[]);
  const [filesNotSupported, setFilesNotSupported] = useState<IFilesToUpload[]>([] as IFilesToUpload[]);
  const [valuesForm, setValuesForm] = useState<FieldValues>([] as FieldValues);
  const [showModalPreview, setShowModalPreview] = useState<boolean>(false);
  const [showModalProcessing, setShowModalProcessing] = useState<boolean>(false);
  const [countNoteDescription, setCountNoteDescription] = useState(0);
  //const [nextReturnReceiptId, setNextReturnReceiptId] = useState<number | null>(null);
  const [showModalLimiteSize, setShowModalLimiteSize] = useState<boolean>(false);
  const { runSuppliersGql, dataSuppliers, errorSuppliers, loadingSuppliers } = useSuppliersGql();
  const { runProductsGql, dataProducts, errorProducts, loadingProducts } = useProductsGql();
  const {
    runReturnReasonsList,
    dataQualityReturnReasonsList,
    errorQualityReturnReasonsList,
    loadingQualityReturnReasonsList
  } = useReturnReasonsListGql();

  const {
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(productReturnFormSchema)
  });

  const handleOnSubmit: SubmitHandler<FieldValues> = async (values) => {
    // As validações já estão feitas, para o cadastro precisamos extrair e criar o objeto
    // Os values são para enviar para API de devolução
    // e filesToUpload para enviar os arquivos para API de upload

    setValuesForm(values);
    setShowModalPreview(true);
  };

  const handleError = (error: any) => {
    if (DEBUG === 'TRUEx') {
      console.log(`Erro ao carregar dados! Error:(message: ${error} )`);
    } else {
      toggleSnackbar({
        message: 'Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.',
        type: 'error',
        duration: 5000
      });
    }
  };

  const handleCreate = async () => {
    setShowModalProcessing(true);
    const returnReceiptId = await handleApiGetNextReturnReceiptId();
    const uploadSuccess = await handleApiUploadFiles(returnReceiptId);
    if (uploadSuccess) {
      await handleApiCreateReturnReceipt(returnReceiptId);
    }
  };

  const handleApiUploadFiles = async (returnReceiptId: number) => {
    let notError = true;
    let nameIndex = 0;
    for (const file of filesToUpload) {
      const stringToFetch = file.filePathBase64 ? file.filePathBase64.toString() : '';
      const blob = await fetch(stringToFetch).then((res) => {
        return res.blob();
      });
      let formData = new FormData();
      formData.append('file', blob);
      nameIndex = nameIndex + 1;
      await api
        .post(paths.quality.uploadPicture, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            userFunctionKey: 'a684eceee76fc522773286a895bc8436'
          },
          params: {
            personId: valuesForm.personId.key,
            returnReceiptId,
            fileName: `${nameIndex}-${file.fileName}`
          }
        })
        .catch((error) => {
          handleError(error);
          notError = false;
        });
      if (!notError) {
        setShowModalPreview(false);
        setShowModalProcessing(false);
        break;
      }
    }
    return notError;
  };

  const handleApiGetNextReturnReceiptId = async () =>
    await api
      .get(paths.quality.getNextReturnReceiptId, {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      })
      .then((res) => {
        return res.data[0].returnReceiptId;
      })
      .catch((error) => {
        handleError(error);
      });

  const handleApiCreateReturnReceipt = async (returnReceiptId: number) => {
    const returnReceiptReasons: any = [];

    valuesForm.returnReceiptReasons.forEach((reason: any) => {
      returnReceiptReasons.push({ reasonId: reason.key });
    });

    await api
      .post(
        paths.quality.createReturnReceipt,
        {
          returnReceiptId,
          personId: +valuesForm.personId.key,
          productId: +valuesForm.productId.key,
          receiptDate: moment(valuesForm.receiptDate).format('DD/MM/YYYY'),
          scheduledQuantity: valuesForm.scheduledQuantity,
          inspectedQuantity: valuesForm.inspectedQuantity,
          returnedQuantity: valuesForm.returnedQuantity,
          noteDescription: valuesForm.noteDescription.toUpperCase(),
          userPersonId: +cookies.get('User-Code'),
          returnReceiptReasons
        },
        {
          headers: {
            userFunctionKey: 'a684eceee76fc522773286a895bc8436'
          }
        }
      )
      .then(() => {
        setShowModalProcessing(false);
        setShowModalPreview(false);
        toggleSnackbar({
          message: 'Adicionado com sucesso',
          type: 'success'
        });
        setTimeout(() => {
          router.push('/qualidade/devolucao');
        }, 3000);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleSelectFiles = () => {
    inputFilesRef.current.click();
  };

  const handleDeleteFile = (key: number) => {
    filesToUpload.splice(key, 1);
    setFilesToUpload([...filesToUpload]);
  };

  const handleFilesUpload = async (e: ChangeEvent<HTMLInputElement>) => {
    const files: File[] = Array.from(e.target.files || []);
    Promise.all(
      files.map((file: File) => {
        return new Promise<IFilesToUpload>((resolve, reject) => {
          if (file.size >= 5000000) {
            resolve({
              fileName: file.name,
              fileOriginal: file,
              fileAllowedSize: false,
              filePathBase64: null,
              fileMime: file.type
            });
          } else {
            const reader = new FileReader();
            reader.addEventListener('load', (e: ProgressEvent<FileReader>) => {
              resolve({
                fileName: file.name,
                fileOriginal: file,
                fileAllowedSize: true,
                filePathBase64: e.target?.result,
                fileMime: file.type
              });
            });
            reader.addEventListener('error', reject);
            reader.readAsDataURL(file);
          }
        });
      })
    ).then(
      (images: IFilesToUpload[]) => {
        setFilesNotSupported(images.filter((item) => !item.fileAllowedSize));
        setFilesToUpload([...images.filter((item) => item.fileAllowedSize), ...filesToUpload]);
      },
      (error: any) => {
        if (DEBUG === 'TRUE') {
          console.log(`Erro ao carregar dados! Error:(message: ${error} )`);
        } else {
          toggleSnackbar({
            message: 'Ocorreu um problema ao carregar imagens. Por favor, informe ao suporte.',
            type: 'error'
          });
        }
      }
    );
  };

  useEffect(() => {
    runSuppliersGql();
    runReturnReasonsList();
  }, []);

  useEffect(() => {
    const obj = watch('personId');
    const personId = Number(obj?.key);
    setValue('productId', undefined);
    if (personId > 0) {
      runProductsGql({ variables: { personId } });
    }
  }, [watch('personId')]);

  useEffect(() => {
    const scheduledQuantity = watch('scheduledQuantity');
    const returnedQuantity = watch('returnedQuantity');
    if (scheduledQuantity >= 0 && returnedQuantity >= 0) {
      const subtract = scheduledQuantity - returnedQuantity;
      setValue('stokedQuantity', subtract);
    }
  }, [watch('scheduledQuantity'), watch('returnedQuantity')]);

  useEffect(() => {
    const reasonsList = watch('returnReceiptReasons');
    if (reasonsList && !reasonsList.length) {
      setValue('returnReceiptReasons', undefined);
    }
  }, [watch('returnReceiptReasons')]);

  useEffect(() => {
    if (errorSuppliers || errorProducts || errorQualityReturnReasonsList) {
      if (DEBUG === 'TRUE') {
        const msg = errorSuppliers || errorProducts || errorQualityReturnReasonsList;
        console.log(`Erro ao carregar dados! Error:(message: ${msg} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorSuppliers, errorProducts, errorQualityReturnReasonsList]);

  useEffect(() => {
    if (filesNotSupported.length > 0) {
      setShowModalLimiteSize(true);
    }
  }, [filesNotSupported]);

  useEffect(() => {
    const count = watch('noteDescription').length;
    setCountNoteDescription(count);
  }, [watch('noteDescription')]);

  useEffect(() => {
    if (filesToUpload.length === 0) {
      setValue('files', '');
    }
  }, [filesToUpload]);

  const selectedProductData = dataProducts.filter((product) => product?.productId === valuesForm?.productId?.key);

  const productInformationData = {
    productDivisionName: selectedProductData[0]?.productDivisionName,
    productGroupId: selectedProductData[0]?.productGroupId,
    productGroupName: selectedProductData[0]?.productGroupName
  };

  const modalPreviewData = { ...valuesForm, ...productInformationData };

  return (
    <>
      <Snackbar />

      {showModalProcessing && <ModalProcessing open={showModalProcessing} />}

      {showModalLimiteSize && (
        <ModalLimiteSize
          filesNotSupported={filesNotSupported}
          open={showModalLimiteSize}
          handleClose={() => setShowModalLimiteSize(false)}
        />
      )}

      {showModalPreview && (
        <ModalPreview
          data={modalPreviewData}
          files={filesToUpload}
          open={showModalPreview}
          onClose={setShowModalPreview}
          onAccept={() => handleCreate()}
        />
      )}

      <PageBarHeader goBack={() => router.push('qualidade/devolucao')} title="Adicionar novo registro de devolução" />

      <form onSubmit={handleSubmit(handleOnSubmit)} className={classes.container}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Typography>Fornecedor</Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Autocomplete
              name="personId"
              control={control}
              showObjectKey
              objects={dataSuppliers}
              objectKey="personId"
              objectValue="supplierName"
              label="Selecione o fornecedor"
              defaultValue=""
              loading={loadingSuppliers}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Typography>Produto devolvido</Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Autocomplete
              control={control}
              name="productId"
              showObjectKey
              objects={dataProducts}
              objectKey="productId"
              objectValue="productName"
              label="ID Prod"
              defaultValue=""
              loading={loadingProducts}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <DatePicker
              control={control}
              name="receiptDate"
              variant="outlined"
              defaultValue={new Date()}
              label="Data do recebimento"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Typography>Descritivo</Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Controller
              name="scheduledQuantity"
              control={control}
              defaultValue=""
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <TextField
                  value={value}
                  onChange={onChange}
                  type="number"
                  inputProps={{ min: 0 }}
                  fullWidth
                  variant="outlined"
                  placeholder="Quantidade agendada"
                  label="Quantidade agendada"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Controller
              name="inspectedQuantity"
              control={control}
              defaultValue=""
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <TextField
                  value={value}
                  onChange={onChange}
                  type="number"
                  inputProps={{ min: 0 }}
                  fullWidth
                  variant="outlined"
                  placeholder="Quantidade vistoriada"
                  label="Quantidade vistoriada"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Controller
              name="returnedQuantity"
              control={control}
              defaultValue=""
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <TextField
                  value={value}
                  onChange={onChange}
                  type="number"
                  inputProps={{ min: 0 }}
                  fullWidth
                  variant="outlined"
                  placeholder="Quantidade devolvida"
                  label="Quantidade devolvida"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Controller
              name="stokedQuantity"
              control={control}
              defaultValue={0}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                  value={value}
                  onChange={onChange}
                  type="number"
                  fullWidth
                  variant="outlined"
                  label="Quantidade estocada"
                  disabled
                  error={!!error}
                  helperText={error?.message || null}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <AutocompleteMultiple
              control={control}
              name="returnReceiptReasons"
              showObjectKey
              objects={dataQualityReturnReasonsList}
              objectKey="reasonId"
              objectValue="reasonDescription"
              label="Motivo da devolução"
              defaultValue=""
              loading={loadingQualityReturnReasonsList}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Controller
              name="noteDescription"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <TextField
                  onChange={onChange}
                  value={value}
                  minRows={3}
                  multiline
                  fullWidth
                  variant="outlined"
                  label="Observações adicionais"
                  placeholder="Observações adicionais"
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength }}
                />
              )}
            />
            <Typography color="primary" style={{ fontSize: '14px' }}>
              Total de caracteres:{' '}
              <b>
                {countNoteDescription}/{maxLength}
              </b>
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Typography>Imagens</Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.imageContainer}>
              {filesToUpload.map((upload, key) => (
                <Fragment key={key}>
                  {upload.fileAllowedSize && (
                    <div className={classes.image} style={{ backgroundImage: `url(${upload.filePathBase64})` }}>
                      <DeleteForeverIcon onClick={() => handleDeleteFile(key)} className={classes.buttonImageDelete} />
                    </div>
                  )}
                </Fragment>
              ))}
              <div style={{ color: 'red' }}>
                <ErrorMessage errors={errors} name="files" />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Controller
              name="files"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  value={value}
                  multiple
                  ref={(el) => {
                    inputFilesRef.current = el!;
                  }}
                  onChange={(e) => {
                    onChange(e);
                    handleFilesUpload(e);
                  }}
                />
              )}
            />

            <Button startIcon={<Add />} variant="text" color="primary" onClick={handleSelectFiles}>
              ADICIONAR ARQUIVOS
            </Button>
          </Grid>

          <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
            <Button variant="contained" color="primary" type="submit">
              SALVAR
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};
